import { Button, Divider, Modal, Select } from "antd";
import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import "./CountryCityTab.css";
import type { ColumnsType } from "antd/es/table";
import { PlusOutlined } from "@ant-design/icons";
import DefaultSelect from "../../components/form/DefaultSelect";
import DefaultInput from "../../components/form/DefaultInput";
import {
	Paper,
	// Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { Table } from "antd";
import { fetchZones } from "../../lib/OptionListApi";
import { AnyAction } from "@reduxjs/toolkit";
import api from "../../utils/axios";
import { toast } from "react-toastify";
import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import useLang from "../../hooks/useLang";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import L, { Icon, LatLngExpression, LatLngTuple } from "leaflet";
import zIndex from "@mui/material/styles/zIndex";
import { hasAccess } from "../../lib/MenuValidation";

const CountryCityTab = () => {
	let defaultExcelExportSettings = {};
	const { strings } = useLang("countryCityTab");
	const defaultColDef = useMemo(
		() => ({
			sortable: true,
			filter: true,
			wrapHeaderText: true,
			resizable: true,
			filterParams: { excelMode: "windows" },
			autoSizeAllColumns: true,
		}),
		[]
	);

	let grid = useRef<AgGridReact | null>(null);
	const [stateName, setStateName] = useState("");
	const [countryName, setCountryName] = useState("");
	const [cityName, setCityName] = useState("");
	const [country, setCountry] = useState<any[]>([]);
	const [city, setCity] = useState<any[]>([]);
	const [zones, setZones] = useState([]);
	const [selectedCountryId, setSelectedCountryId] = useState<number | any>(1);
	const [openCountryModal, setOpenCountryModal] = useState<boolean>(false);
	const [openCityModal, setOpenCityModal] = useState<boolean>(false);
	const [openSectionDetailsModal, setOpenSectionDetailsModal] =
		useState<boolean>(false);
	const [openZoneModal, setOpenZoneModal] = useState<boolean>(false);
	const [zoneDescription, setZoneDescription] = useState<string>("");
	const [countryOptions, setCountryOptions] = useState<any>([]);
	const [cityOptions, setCityOptions] = useState<any>([]);
	const [cities, setCities] = useState<any>([]);
	const [countryId, setCountryId] = useState<string | undefined>();
	const [cityId, setCityId] = useState<string | undefined>();
	const [sections, setSections] = useState<any[]>([]);
	const [sectionId, setSectionId] = useState<any>();

	const handleModalCancel = () => {
		setOpenCityModal(false);
		setCityName("");
		setStateName("");
		setCountryName("");
	};

	const fetchSections = async () => {
		try {
			const response = await api.get("Zone/select-sections");
			if (response.status === 200) {
				setSections(response?.data);
			}
		} catch (error) {
			console.log(error);
		}
	};
	const handleAddCountry = async () => {
		try {
			const response = await api.post("Zone/insert-country", {
				description: stateName,
			});

			if (response.status === 200) {
				getZones();
				handleModalCancel();
			} else {
				console.error(
					"Failed to add country. Status: ",
					response.status
				);
			}
		} catch (error: any) {
			toast.error(strings?.addCountryErrorMessage);
		}
	};

	const handleAddCity = async () => {
		try {
			const response = await api.post("Zone/insert-city", {
				description: cityName,
				parentId: selectedCountryId,
				currencyId: selectedCountryId,
			});

			if (response.status === 200) {
				getZones();
				handleModalCancel();
			} else {
				console.error(
					"Failed to add country. Status: ",
					response.status
				);
			}
		} catch (error: any) {
			console.error(strings?.addCityErrorMessage);
		}
	};

	const getZones = useCallback(async () => {
		const allZones = await fetchZones();
		if (allZones) {
			const displayCountries = allZones
				.filter((item: any) => item.levelId === 1)
				.map((item: any) => ({
					key: item.id,
					code: item.code,
					description: item.description,
				}));

			const displayedCities = allZones
				.filter((item: any) => item.levelId === 2)
				.map((item: any) => ({
					key: item.id,
					code: item.code,
					description: item.description,
					parentId: item.parentId,
				}));
			setZones(allZones);
			setCountry(displayCountries);
			setCity(displayedCities);

			const countries = allZones
				.filter((item: any) => item.levelId === 1)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCountryOptions(countries);

			const filteredCities = allZones
				.filter((item: any) => item.levelId === 2)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCityOptions(filteredCities);

			const modalCity = allZones?.filter(
				(item: any) => item.levelId === 2
			);
			setCities(modalCity);

			const defaultCountryId = 1;
			filterCitiesByCountry(defaultCountryId, displayedCities);
		}
	}, []);

	const [filteredCities, setFilteredCities] = useState<any[]>([]);

	const handleCountryFilterChange = (value: number | any | null) => {
		setSelectedCountryId(value);
		filterCitiesByCountry(value);
	};

	const filterCitiesByCountry = (countryId: number, cities = city) => {
		const filtered = cities.filter(
			(cityItem: any) => cityItem.parentId === countryId
		);
		setFilteredCities(filtered);
	};
	useEffect(() => {
		getZones();
	}, []);

	useEffect(() => {
		filterCitiesByCountry(selectedCountryId);
	}, [city]);

	const columns = [
		{
			title: strings?.stateNameLabel,
			dataIndex: "description",
			key: "description",
			render: () => (
				<div className="h-[16rem] ">
					<Select
						placeholder={strings?.selectCountry}
						style={{ width: "7.875rem", height: "2.625rem" }}
						allowClear
						onChange={(value) => handleCountryFilterChange(value)}
						value={selectedCountryId}
					>
						{country.map((countryItem) => (
							<Select.Option
								key={countryItem.key}
								value={countryItem.key}
							>
								{countryItem.description}
							</Select.Option>
						))}
					</Select>
				</div>
			),
		},
		{
			title: strings?.codeColumn,
			dataIndex: "code",
			key: "code",
			render: () =>
				selectedCountryId
					? country.find((item) => item.key === selectedCountryId)
							?.code
					: "",
		},
		{
			title: strings?.cityLabel,
			dataIndex: "cities",
			key: "cities",
			render: () => (
				<ul className="overflow-y-auto">
					{filteredCities?.map((cityItem) => (
						<li key={cityItem.key}>{cityItem.description}</li>
					))}
				</ul>
			),
		},
	];

	const sectionTableColumns = [
		{
			field: "id",
			headerName: "Id",
			width: 120,
		},
		{
			field: "sectionDescription",
			headerName: strings?.zoneDescription,
			width: 180,
		},
		{
			field: "cityDescription",
			headerName: strings?.cityLabel,
			width: 180,
		},
	];

	const renderCountryOptions = () => {
		const countryOptions = zones
			.filter((country: any) => country.levelId === 1)
			.map((country: any) => ({
				value: country.id,
				label: country.description,
				levelId: country.levelId,
			}));

		return [...countryOptions];
	};

	const handleCountrySelect = (value: any) => {
		setSelectedCountryId(value);
	};

	const onCountrySelect = (e: any) => {
		const filteredCities = cities
			.filter((item: any) => item.parentId === e)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityOptions(filteredCities);
		setCountryId(e);
		setCityId("");
	};

	const onCitySelect = (e: any) => {
		setCityId(e);
	};

	const handleZoneEdit = async () => {
		const data = {
			id: sectionId,
			countryId: countryId,
			cityId: cityId,
			sectionDescription: zoneDescription,
		};
		try {
			const response = await api.post("Zone/update-section", data);
			if (response.status === 200) {
				toast.success(strings?.editZoneSuccessMessage);
				fetchSections();
				cleanZoneModal();
			}
		} catch (error: any) {
			console.log(strings?.editZoneErrorMessage);
			toast.error(error.message);
		}
	};

	const handleZoneInsert = async () => {
		if (sectionId && sectionId !== null && sectionId !== "") {
			handleZoneEdit();
		} else {
			const section = {
				description: zoneDescription,
				parentId: cityId,
				countryId: countryId,
			};
			if (!countryId) {
				toast.error(strings?.stateNotSelectedError);
				return false;
			}
			if (!cityId) {
				toast.error(strings?.cityNotSelectedError);
				return false;
			}
			if (!zoneDescription) {
				toast.error(strings?.zoneDescriptionNotSelectedError);
				return false;
			}
			try {
				const response = await api.post("Zone/insert-section", section);
				if (response.status === 200) {
					toast.success(strings?.addZoneSuccessMessage);
					getZones();
					cleanZoneModal();
				}
			} catch (error) {
				console.log(error);
			}
		}
	};
	const cleanZoneModal = () => {
		setCountryId("");
		setZoneDescription("");
		setCityId("");
		setSectionId("");
		setOpenZoneModal(false);
	};

	const onFirstDataRendered = useCallback((params: any) => {
		(grid.current as any).api.sizeColumnsToFit();
	}, []);

	const openEditModal = (rowData: any) => {
		if (hasAccess("ZONE_MANAGEMENT_UPSERT_ACCESS")) {
			const data = rowData?.data;
			if (data) {
				setSectionId(data?.id);
				setCountryId(data?.countryId);
				setCityId(data?.cityId);
				setZoneDescription(data?.sectionDescription);
				setOpenZoneModal(true);
			}
		} else {
			return;
		}
	};
	const [mapCenter, setMapCenter] = useState<LatLngTuple | null>([
		42.6026, 20.903,
	]);

	const [position, setPosition] = useState<any>(null);

	const markerRef = useRef(null);

	const eventHandlers = useMemo(
		() => ({
			dragend() {
				const marker = markerRef.current;
				if (marker != null) {
					const latLng = marker["_latlng"];
					setPosition(latLng);
				}
			},
		}),
		[]
	);

	const customIcon = new Icon({
		iconUrl: require("../../assets/pin.png"),
		iconSize: [38, 38],
	});

	return (
		<>
			<div className="mainComponent">
				<div className="firstComponent">
					<h1 className="text-lg">{strings?.citiesAndStates}</h1>
					<div className="buttons">
						{/* <Button
							className="border-[#4F16C233] text-[#4F16C2] flex items-center"
							onClick={() => setOpenCountryModal(true)}
						>
							<PlusOutlined />
							Shto shtet
						</Button> */}
						<div className="buttonsMain">
							{hasAccess("ZONE_MANAGEMENT_UPSERT_ACCESS") && (
								<>
									<Button
										className="border-[#4F16C233] text-[#4F16C2] flex items-center"
										onClick={() => setOpenCityModal(true)}
									>
										<PlusOutlined />
										{strings?.cityModalTitle}
									</Button>
									<Button
										className="border-[#4F16C233] text-[#4F16C2] flex items-center"
										onClick={() => setOpenZoneModal(true)}
									>
										<PlusOutlined />
										{strings?.zoneModalTitle}
									</Button>
								</>
							)}
							<Button
								className="border-[#4F16C233] text-[#4F16C2] flex items-center"
								onClick={() => {
									fetchSections();
									setOpenSectionDetailsModal(true);
								}}
							>
								<PlusOutlined />
								{strings?.viewZonesButtonLabel}
							</Button>
						</div>
					</div>
				</div>
				<div className="secondComponent">
					<div className="mapComponent">
						{/* <iframe
							srcDoc={`<iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d375579.29073231167!2d21.19234075171777!3d42.65683705388461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1699350441377!5m2!1sen!2s"
                                width="600"
                                height="450"
                                style="border:0;"
                                allowfullscreen=""
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                            ></iframe>`}
							width="500"
							height="400"
							style={{ border: 0 }}
							allowFullScreen
							loading="lazy"
							referrerPolicy="no-referrer-when-downgrade"
							title="Google Maps"
						/> */}
						{mapCenter && (
							<MapContainer
								center={mapCenter}
								zoom={7.5}
								scrollWheelZoom={true}
								// className={classes.mapContainerRegisterForm}
								className="mapContainerCountryCity"
							>
								<TileLayer
									attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
									url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
								/>
								{position && (
									<>
										<Marker
											draggable={true}
											position={position}
											icon={customIcon}
											eventHandlers={eventHandlers}
											ref={markerRef}
										>
											<Popup
												minWidth={90}
											>{`Position${position}`}</Popup>
										</Marker>
									</>
								)}
							</MapContainer>
						)}
					</div>
					<div className="countriesComponent">
						<Table
							columns={columns}
							dataSource={[{ key: "1" }]}
							pagination={false}
							className="tableCountryCity"
						/>
					</div>
				</div>
			</div>
			<Modal
				open={openCountryModal}
				title={strings?.countryModalTitle}
				onCancel={() => setOpenCountryModal(false)}
				onOk={handleAddCountry}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
			>
				<Divider />
				<div className="flex flex-col items-center">
					<DefaultInput
						placeholder={strings?.stateNamePlaceholder}
						value={stateName}
						label={strings?.stateNameLabel}
						onChange={(e) => setStateName(e.target.value)}
						className="registerInput"
					/>
					<DefaultInput
						placeholder={strings?.countryNamePlaceholder}
						label={strings?.countryNameLabel}
						value={countryName}
						onChange={(e) => setCountryName(e.target.value)}
						className="registerInput"
					/>
				</div>
			</Modal>
			<Modal
				open={openCityModal}
				title={strings?.countryModalTitle}
				onCancel={() => setOpenCityModal(false)}
				onOk={handleAddCity}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
			>
				<Divider />
				<div className="flex flex-col items-center gap-5">
					<DefaultSelect
						label={strings?.stateNameLabel}
						flexDirection="col"
						alignCenter="start"
						placeholder={strings?.selectState}
						className="registerInput"
						options={renderCountryOptions()}
						onChange={handleCountrySelect}
					/>
					<DefaultInput
						placeholder={strings?.selectCity}
						value={cityName}
						label={strings?.cityLabel}
						onChange={(e) => setCityName(e.target.value)}
						className="registerInput"
					/>
				</div>
			</Modal>
			<Modal
				open={openZoneModal}
				title={strings?.zoneModalTitle}
				onCancel={cleanZoneModal}
				onOk={handleZoneInsert}
				okButtonProps={{
					style: { backgroundColor: "#4F16C2", zIndex: 5000 },
				}}
			>
				<Divider />
				<div className="flex flex-col items-center gap-5">
					<DefaultSelect
						label={strings?.stateNameLabel}
						flexDirection="col"
						alignCenter="start"
						placeholder={strings?.selectState}
						className="registerInput"
						options={countryOptions}
						onChange={onCountrySelect}
						value={countryId}
					/>
					<DefaultSelect
						label={strings?.cityLabel}
						flexDirection="col"
						alignCenter="start"
						placeholder={strings?.selectCity}
						className="registerInput"
						options={cityOptions}
						onChange={onCitySelect}
						value={cityId}
					/>
					<DefaultInput
						placeholder={strings?.cityPlaceholder}
						value={zoneDescription}
						label={strings?.zoneDescriptionLabel}
						onChange={(e) => setZoneDescription(e.target.value)}
						className="registerInput"
					/>
				</div>
			</Modal>
			<Modal
				open={openSectionDetailsModal}
				title={strings?.zoneTitle}
				onCancel={() => setOpenSectionDetailsModal(false)}
				okButtonProps={{ style: { display: "none" } }}
				cancelButtonProps={{ style: { display: "none" } }}
				width={700}
			>
				<Divider />
				<div
					className="ag-theme-alpine"
					style={{
						width: "100%",
						height: "auto",
					}}
				>
					<AgGridReact
						rowData={sections}
						columnDefs={sectionTableColumns}
						defaultColDef={defaultColDef}
						undoRedoCellEditing={true}
						undoRedoCellEditingLimit={20}
						suppressCopyRowsToClipboard={true}
						defaultExcelExportParams={defaultExcelExportSettings}
						ref={grid}
						enableRangeSelection={true}
						cacheQuickFilter={true}
						domLayout="autoHeight"
						suppressPaginationPanel={false}
						rowHeight={60}
						onFirstDataRendered={onFirstDataRendered}
						onRowClicked={openEditModal}
					/>
				</div>
			</Modal>
		</>
	);
};

export default CountryCityTab;
